//----------------------------------------------------- // GENERIC FUNCTIONS // ---------------------------------------------------


export function orderByTimestamp(dataArray) {
  const data = dataArray
  return data.sort(
    (a, b) => parseFloat(b.data?.seconds) - parseFloat(a.data?.seconds)
  );
}

export function orderByTimestampDin(dataArray, keyName) {
  const data = dataArray
  return data.sort(
    (a, b) => parseFloat(b[keyName]?.seconds) - parseFloat(a[keyName]?.seconds)
  );
}

export function formatDate(date) {
  return new Date(date?.seconds * 1000).toLocaleString()
}

export function toISOFormat(date) {
  Number.prototype.zeroPad = function () {
    return ('0' + this).slice(-2);
  };
  const format = {
    dd: date.getDate().zeroPad(2),
    mm: (date.getMonth() + 1).zeroPad(2),
    yyyy: date.getFullYear(),
    HH: date.getHours().zeroPad(2),
    MM: date.getMinutes().zeroPad(2),
    SS: date.getSeconds().zeroPad(2),
  };
  const { dd, mm, yyyy, HH, MM } = format
  return `${yyyy}-${mm}-${dd}T${HH}:${MM}`;
}

export function checkPermissions(module, modulePermissions, permission) {
  if (modulePermissions && permission) {
    let returnedValue
    Object.entries(modulePermissions).forEach((item) => {
      if (item[0] == module)
        returnedValue = item[1]
    })
    if (permission === 'admin')
      return 4
    switch (returnedValue) {
      case "edicao":
        return 3
      case "leitura":
        return 2
      case "restrito":
        return 1
      default:
        return 0
    }
  }
  return null
}
